import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import moment from '../../../../lib/moment.js'
import shortid from 'shortid'
import get from 'lodash/get'
import find from 'lodash/find'
import { leaveColor } from '../../helpers/color'
import * as timesheetHelper from '../../helpers/timesheet'
import * as CONSTANTS from '../../constants'

const generateSumHours = (selectedDateProjects) => {
  const sumHours = []
  const run = moment(selectedDateProjects).startOf('month')
  const endDate = moment(selectedDateProjects).endOf('month')
  while (run.isBefore(endDate, 'day') || run.isSame(endDate, 'day')) {
    sumHours[run.format('YYYY-MM-DD')] = ''
    run.add(1, 'days')
  }
  return sumHours
}

export const DataInput = (props) => {
  const { timesheetProject } = props
  const { handleClickCell } = props
  const compensateRequests = get(timesheetProject, 'compensateRequests')
  const holidays = timesheetHelper.changeFormatDate(get(props, 'holidaysByProject'))
  const leaveRequests = get(timesheetProject, 'leavesRequests')
  const sumHoursByDate = get(timesheetProject, 'sumHoursByDate', generateSumHours(moment(get(props, 'selectedDateProjects'), 'MM/YYYY').format('YYYY-MM')))
  const sumHours = get(timesheetProject, 'sumHours', '')
  const sumWmd = get(timesheetProject, 'sumWmd', '')

  return (
    <Column>
      <Total>{ sumHours }</Total>
      <Total>{ sumHours !== '' ? (parseFloat(sumHours) / 8).toFixed(2) : '' }</Total>
      <Total>{ sumWmd }</Total>
      {Object.keys(sumHoursByDate).sort().map(sum => {
        const isWeekend = moment(sum).day() === 0 || moment(sum).day() === 6
        const isHoliday = find(holidays, { date: sum })
        const hasLeave = timesheetHelper.checkHasLeaveRequest(leaveRequests, { date: sum })
        const hasCompensate = timesheetHelper.checkHasLeaveRequest(
          compensateRequests, { date: sum })

        let day = ''
        let dataType
        let data

        if (isWeekend) day = CONSTANTS.WEEKEND
        else if (isHoliday) {
          day = CONSTANTS.HOLIDAY
          dataType = day
          data = isHoliday
        } if (hasLeave) {
          day = hasLeave.length > 1 ? CONSTANTS.FULLDAY : hasLeave[0].leave_time
          dataType = day
          data = hasLeave
        } else if (hasCompensate) {
          day = CONSTANTS.COMPENSATE
          dataType = day
          data = hasCompensate
        }

        return (
          <Cell
            key={ shortid() }
            day={ day }
            canClick={ isHoliday || hasLeave || hasCompensate }
            onClick={
              (isHoliday || hasLeave || hasCompensate) ?
                () => handleClickCell(dataType, data) : () => {}
            }
          >
            <Hour>{ sumHoursByDate[sum] === 0 ? '' : sumHoursByDate[sum] }</Hour>
          </Cell>
        )
      })}
    </Column>
  )
}

DataInput.propTypes = {
  timesheetProject: PropTypes.object,
  handleClickCell: PropTypes.func.isRequired,
}
DataInput.defaultProps = {
  timesheetProject: {},
}

const Column = styled.div`
  height: 100%;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  border: solid #EAEAEA;
  border-width: 0px 1px 0px 0px;
`
const Cell = styled.div`
  font-family: 'Gotham' !important;
  font-size: 10px;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: ${props => { return props.canClick ? 'pointer' : 'default' }};
  border: solid #EAEAEA;
  border-width: 0px 0px 0px 1px;
  background-color: ${(props) => { return leaveColor(props.day) }};
`
const Total = styled.span`
  width: 50px;
  font-family: 'Gotham-Bold';
  font-size: 12px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  border: solid #EAEAEA;
  border-width: 0px 0px 0px 1px;
`
const Hour = styled(Total)`
  border: 0px;
  font-family: 'Gotham';
`




// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/timesheet-by-project/input-col.js